export const titleCase = (str) => {
  str = str ?? '';
  str = str.replaceAll('_', ' ');
  return str.toLowerCase().replace(/\b(\w)/g, (s) => s.toUpperCase());
};
